<template>
    <transition name="fade">
      <div v-if="isOpen" class="overlay" @click="cancel">
        <transition name="scale">
          <div class="modal" @click.stop>
            <h3 class="title">{{ title }}</h3>
  
            <p v-if="description" class="description">
              {{ description }}
            </p>
  
            <div class="buttons">
              <button class="cancel-btn" @click="cancel">
                Отмена
              </button>
  
              <button class="confirm-btn" @click="confirm">
                Удалить
              </button>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </template>
  
  <script setup>
  const props = defineProps({
    isOpen: Boolean,
    title: String,
    description: String
  })
  
  const emit = defineEmits(["confirm", "cancel"])
  
  const confirm = () => emit("confirm")
  const cancel = () => emit("cancel")
  </script>
  
  <style scoped>
  
  /* Overlay */
  .overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    backdrop-filter: blur(6px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
  }
  
  /* Modal */
  .modal {
    width: 100%;
    max-width: 380px;
    background: white;
    border-radius: 20px;
    padding: 28px 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  }
  
  [data-theme="dark"] .modal {
    background: #1f1f1f;
    color: white;
  }
  
  /* Title */
  .title {
    font-family: "Eastman-Bold", sans-serif;
    font-size: 16px;
    margin-bottom: 12px;
    text-align: center;
  }
  
  .description {
    font-size: 13px;
    opacity: 0.7;
    margin-bottom: 24px;
    text-align: center;
  }
  
  /* Buttons */
  .buttons {
    display: flex;
    gap: 12px;
  }
  
  .cancel-btn {
    flex: 1;
    padding: 12px;
    border-radius: 14px;
    border: 1px solid #ddd;
    background: transparent;
    cursor: pointer;
    transition: 0.2s;
  }
  
  .cancel-btn:hover {
    background: rgba(0,0,0,0.05);
  }
  
  .confirm-btn {
    flex: 1;
    padding: 12px;
    border-radius: 14px;
    border: none;
    background: linear-gradient(135deg, #ff4d4d, #d93636);
    color: white;
    font-family: "Eastman-Bold", sans-serif;
    cursor: pointer;
    transition: 0.2s;
  }
  
  .confirm-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(255, 77, 77, 0.4);
  }
  
  /* Animations */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.25s ease;
  }
  
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
  
  .scale-enter-active {
    transition: all 0.25s cubic-bezier(0.22, 1, 0.36, 1);
  }
  
  .scale-enter-from {
    transform: scale(0.85);
    opacity: 0;
  }
  
  .scale-leave-active {
    transition: all 0.2s ease;
  }
  
  .scale-leave-to {
    transform: scale(0.85);
    opacity: 0;
  }
  
  </style>